import React, { useState } from 'react';

export default function ExportToolbar({ onExportCSV, onExportJSON, disabled }) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen((v) => !v)}
        disabled={disabled}
        style={{
          padding: '8px 14px', background: '#111827', color: '#fff',
          border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600',
          cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
          display: 'inline-flex', alignItems: 'center', gap: '6px',
        }}
      >
        ↓ Export <span style={{ fontSize: '10px' }}>▾</span>
      </button>

      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 100 }} />
          <div style={{
            position: 'absolute', right: 0, top: 'calc(100% + 4px)',
            background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)', zIndex: 101,
            minWidth: '170px', overflow: 'hidden',
          }}>
            {onExportCSV && (
              <button onClick={() => { onExportCSV(); setOpen(false); }} style={{
                display: 'flex', alignItems: 'center', gap: '10px',
                width: '100%', padding: '10px 16px', background: 'none',
                border: 'none', cursor: 'pointer', fontSize: '13px', color: '#374151',
                textAlign: 'left',
              }}>
                📊 Export as CSV
              </button>
            )}
            {onExportJSON && (
              <button onClick={() => { onExportJSON(); setOpen(false); }} style={{
                display: 'flex', alignItems: 'center', gap: '10px',
                width: '100%', padding: '10px 16px', background: 'none',
                border: 'none', cursor: 'pointer', fontSize: '13px', color: '#374151',
                textAlign: 'left', borderTop: '1px solid #f3f4f6',
              }}>
                📋 Export as JSON
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
